import { render, staticRenderFns } from "./playlist-item.vue?vue&type=template&id=c0335bec&scoped=true&"
import script from "./playlist-item.vue?vue&type=script&lang=js&"
export * from "./playlist-item.vue?vue&type=script&lang=js&"
import style0 from "./playlist-item.vue?vue&type=style&index=0&id=c0335bec&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0335bec",
  null
  
)

export default component.exports